export default __webpack_public_path__ + "static/media/notification-sound.a40c07be.mp3";